import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    padding: ${theme.layout.chat_header_height} ${theme.layout.section_side}
      calc(${theme.layout.chat_navigation_height} + 30px);
  `}
`;

export const Name = styled.div`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body18_medium}
  `}
`;

export const Desc = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background: ${theme.stroke.stroke_1};
  `}
`;

export const Section = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 10px;

    & > h2 {
      ${theme.fontStyle.poppins.desc}
      color: ${theme.themeColor.main_light};
    }

    & p {
      display: inline-block;
      ${theme.fontStyle.text.body16_medium}
      color: ${theme.content.content_light_1};

      &.italic {
        color: ${theme.content.content_light_4};
        font-style: italic;
      }
    }
  `}
`;

export const ButtonBox = styled.div`
  ${({ theme }) => css`
    display: block;
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    max-width: ${breakpoint.mobile_large};
    padding: 0 ${theme.layout.section_side} 20px;
    transform: translateX(-50%);
  `}
`;

export const EmojiContainer = styled.div`
  display: flex;
  position: relative;
  align-content: center;
  gap: 4px;
`;

export const EmojiDefaultWrapper = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    width: 56px;
    height: 32px;
    padding: 8px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 8px;

    img {
      width: 16px;
      height: 16px;
    }
  `}
`;
